import { StateModel } from 'src/shared/models';
import {
  GET_EVENT_REPORT,
  GET_EVENT_REPORT_SUCCESS,
  GET_EVENT_REPORT_ERROR,
  CLEAR_EVENT_REPORT,
} from '../actions/event-report.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const eventReportReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_EVENT_REPORT:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_EVENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case GET_EVENT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        error,
      };
    case CLEAR_EVENT_REPORT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
